import React from 'react'
import '../assets/static/header.css'

const Title = () => {
  return (
    <div className='my-title'>
        <h3>Explore to Find Your Perfect Course</h3>
      
    </div>
  )
}

export default Title
